export default function CorrectAnswerDirection({ alternatives = [], correctLetters = [], className = "" }) {
  const explicit = new Set((correctLetters || []).map((value) => String(value || "").trim().toUpperCase()));
  const correct = (alternatives || []).filter((alternative) => {
    const letter = String(alternative?.letter || "").trim().toUpperCase();
    return Boolean(alternative?.is_correct) || explicit.has(letter);
  });

  if (!correct.length) return null;

  return (
    <div
      className={`border border-emerald-600 bg-emerald-50 p-3 text-emerald-950 ${className}`.trim()}
      data-testid="correct-answer-direction"
    >
      <strong>{correct.length === 1 ? "Resposta correta:" : "Respostas corretas:"}</strong>{" "}
      {correct.map((alternative, index) => (
        <span key={`${alternative.letter}-${index}`}>
          {index > 0 ? " · " : ""}
          <b>{String(alternative.letter || "").toUpperCase()}</b>
          {alternative.text ? ` — ${alternative.text}` : ""}
        </span>
      ))}
    </div>
  );
}
